import * as React from 'react';

import { angularProviderHOC } from '../../../common/react/AngularProviderHOC';
import { ReactDirectiveProps } from '../../../ts/directives/reactDirectiveFactory';
import { BrowserTitleService } from '../../../ts/services/BrowserTitleService';
import { HelpService } from '../../../ts/services/HelpService';
import { ServerService } from '../../../ts/services/ServerService';
import { Telemetry } from '../../../ts/services/TelemetryService';
import { ToasterService } from '../../../ts/services/ToasterService';
import { ServiceLocator } from '../../ServiceLocator';
import { SpaceInfo, SpaceItemForNonEntitySpace } from '../../state/SpaceInfo';
import { ConnectedSpaceInfoProvider } from '../RouterHelpers/SpaceInfoProvider';
import { SpacesSiteUrls } from '../SpacesSiteUrls';
import { ConnectedStartersSpace } from './ConnectedStartersSpace';
import { StartersSpaceAngularProps, StartersSpaceOwnProps } from './StartersSpace';

export interface StartersSpaceProviderProps extends ReactDirectiveProps {
  readonly routeLocationPath: string;
  readonly routeLocationSearch: string;
  readonly urls: SpacesSiteUrls;
  readonly connectionType?: string;
}

const StartersSpaceAngularHOC = angularProviderHOC<StartersSpaceOwnProps, StartersSpaceAngularProps, StartersSpaceAngularProps>({
  getAngularServicesWithServiceLocator: () => ({
    browserTitleService: ServiceLocator.get<BrowserTitleService>('BrowserTitleService'),
    helpService: ServiceLocator.get<HelpService>('HelpService'),
    serverService: ServiceLocator.get<ServerService>('ServerService'),
    telemetry: ServiceLocator.get<Telemetry>('TelemetryService'),
    toasterService: ServiceLocator.get<ToasterService>('ToasterService'),
  }),
  selectPropsFromAngularServices: angularServices => angularServices,
});

const AngularWrappedStartersSpace: React.ComponentType<StartersSpaceOwnProps>
  = StartersSpaceAngularHOC(ConnectedStartersSpace);

const StartersSpaceInfo: SpaceInfo = {
  item: SpaceItemForNonEntitySpace,
  spaceType: 'starters',
  subspaceName: undefined
};

export const StartersSpaceProvider: React.FunctionComponent<StartersSpaceProviderProps> = (props) => {

  return (
    <ConnectedSpaceInfoProvider spaceInfo={StartersSpaceInfo}>
      <AngularWrappedStartersSpace angularContext={props.angularContext} urls={props.urls} selectedConnectionTypeInternalName={props.connectionType}/>
    </ConnectedSpaceInfoProvider>
  );
};
